// From https://colinhacks.com/essays/reasonable-email-regex
export const isValidEmail = (email: string): boolean => {
  return Boolean(email.match(/^(?!\.)(?!.*\.\.)([a-z0-9_'+\-\.]*)[a-z0-9_'+\-]@([a-z0-9][a-z0-9\-]*\.)+[a-z]{2,}$/i));
};
